import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import useVoyagerStore from '../../stores/useVoyagerStore';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';
import type { LadderAnswer } from '../Ladder/claims';

/**
 * The earlier answer an answer used (#1807, F2 §5; #1892 Q4): "Based on your answer 2: Revenue by market · Apr 1–30, 2026", or
 * "Comparing answer 3 with answer 1 …", the server's code words for this viewer now — and *Not that one*, which asks
 * the question again exactly as it was sent, with `earlier: "none"` (no earlier answer read). Nothing without a line.
 */
export default function EarlierLine({ turn }: { turn: LandingAgentTurn }) {
  const ladder = turn.result?.ladder as LadderAnswer | null | undefined;
  const send = useVoyagerStore((s) => s.sendLandingAgentQuery);
  const line = ladder?.earlier?.line;
  if (!line) return null;
  const reask = turn.askedRequest;
  return (
    <Box data-testid="earlier-line" sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', minWidth: 0 }}>
      <Typography variant="caption" data-testid="earlier-said"
                  sx={{ color: 'var(--ink-2)', minWidth: 0, overflowWrap: 'anywhere' }}>
        {line}
      </Typography>
      {reask && <Button size="small" variant="text" data-testid="earlier-not-that-one"
                        onClick={() => send(reask.query, { reask, earlier: 'none' })}
                        sx={{ minWidth: 0, px: 0.75, textTransform: 'none', color: 'var(--accent)' }}>
        Not that one
      </Button>}
    </Box>
  );
}
